import { formatDate } from "../../../../../../../components/common/Converter";

export default function PrintServiceRecord(objects, remarks, object) {
  console.log("objects: ", objects);
  console.log("objects: ", object);
  console.log("REEE: ", remarks);

  let middleName = object?.Middlename || "";
  if (object.civil === "Married" && object?.sex === "Female") {
    middleName = object?.mothersurName || "";
  }

  const sortedObjects = [...(objects || [])].sort((a, b) => {
    const dateA = new Date(a.from);
    const dateB = new Date(b.from);
    return dateA - dateB; // ascending: oldest first
  });
  const employeeName = `${object?.surname || ""} ${object?.Firstname || ""} ${
    object?.Middlename || ""
  }`;

  const headerData = (title, content, label, information) => {
    return (
      <div style={{ display: "flex", marginTop: "1rem" }}>
        <label style={{ marginRight: "1rem", fontWeight: "bold" }}>
          {title}{" "}
        </label>
        <div
          style={{
            display: "grid",
            width: "100%",
            // border: "1px solid",
            height: "3rem",
          }}
        >
          <div
            style={{
              borderBottom: "1px solid",
              display: "flex",
              // justifyContent: "space-evenly",
              textAlign: "center",
            }}
          >
            {content}
          </div>
          <div
            style={{
              display: "flex",
              // justifyContent: "space-between",
              textAlign: "center", // Centering the text
            }}
          >
            {label}
          </div>
        </div>
        <div style={{ textAlign: "center", fontSize: "12px", width: "20%" }}>
          <label>{information}</label>
        </div>
      </div>
    );
  };

  return (
    <div
      style={{
        // padding: "1rem",
        marginTop: "10rem",
        paddingLeft: "2rem",
        paddingRight: "2rem",
        display: "grid",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <header
        style={{ textAlign: "center", display: "grid", marginBottom: "2rem" }}
      >
        <label style={{ fontSize: "2rem" }}>
          <b>SERVICE RECORD</b>
        </label>
        <label>(To be accomplished by Employer)</label>
      </header>
      {headerData(
        "NAME:",
        [
          <>
            <label style={{ width: "32%", fontWeight: "bold" }}>
              {object?.surname || ""}
            </label>
            <label style={{ width: "32%", fontWeight: "bold" }}>
              {object?.Firstname || ""}
            </label>
            <label style={{ width: "32%", fontWeight: "bold" }}>
              {object?.Middlename || ""}
            </label>
          </>,
        ],
        [
          <>
            <label style={{ width: "32%", fontSize: "12px" }}>(Surname)</label>
            <label style={{ width: "32%", fontSize: "12px" }}>
              (Given Name)
            </label>
            <label style={{ width: "32%", fontSize: "12px" }}>
              (Middle Name)
            </label>
          </>,
        ],
        "(If married woman give also full mainden name)"
      )}
      {headerData(
        "BIRTH:",
        [
          <>
            <label style={{ width: "50%", fontWeight: "bold" }}>
              {object?.birthDate ? formatDate(object?.birthDate) : ""}
            </label>
            <label style={{ width: "50%", fontWeight: "bold" }}>
              {object?.birthPlace || ""}
            </label>
          </>,
        ],
        [
          <>
            <label style={{ width: "50%", fontSize: "12px" }}>
              (Date of Birth)
            </label>
            <label style={{ width: "50%", fontSize: "12px" }}>
              (Place of Birth)
            </label>
          </>,
        ],
        "(Data herein should be cheked from birth or some other reliable document)"
      )}

      <div style={{ textIndent: "5rem", margin: "2rem" }}>
        <p>
          This is to certify that the employee named hereinabove actually
          rendered services in this Office as shown by the service record below,
          each line of which is supported by appointment and other papers
          actually issues by this Office and approved by the authorities
          concerned.
        </p>
      </div>

      <table
        border="1"
        cellPadding="5"
        style={{
          borderCollapse: "collapse",
          width: "100%",
          textAlign: "center",
          fontSize: "12px",
        }}
      >
        <thead>
          <tr>
            <th colSpan="2">SERVICE (Inclusive Dates)</th>
            <th colSpan="3">RECORD OF APPOINTMENT</th>
            <th colSpan="3">OFFICE ENTITY/DIVISION</th>
            <th colSpan="2">SEPARATION (4)</th>
          </tr>
          <tr>
            <th>FROM</th>
            <th>TO</th>
            <th>DESIGNATION</th>
            <th>Status (1)</th>
            <th>Salary (P/A) (2)</th>
            <th>STATION/PLACE OF ASSIGNMENT</th>
            <th>Branch (3)</th>
            <th>LEAVE/ABSENCE w/o PAY</th>
            <th>DATE</th>
            <th>CAUSE</th>
          </tr>
        </thead>

        <tbody>
          {sortedObjects?.length > 0 &&
            sortedObjects.map((item, index) => {
              const salaryMatch = item?.salary?.match(/₱\s?([\d,]+\.\d{2})/);
              const salary = salaryMatch
                ? parseFloat(salaryMatch[1].replace(",", ""))
                : null;
              const formattedSalary = new Intl.NumberFormat("en-US", {
                style: "decimal",
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
              }).format(salary);
              return (
                <tr key={index}>
                  <td>
                    {item?.from
                      ? new Date(item?.from).toLocaleDateString("en-US")
                      : ""}
                  </td>
                  <td>
                    {item?.to
                      ? new Date(item?.to).toLocaleDateString("en-US")
                      : "PRESENT"}
                  </td>
                  <td>{item?.designation}</td>
                  <td>{item?.status}</td>
                  <td>{formattedSalary}</td>
                  <td>{item?.station}</td>
                  <td>{item?.branch}</td>
                  <td>{item?.leave?.join("; ") || "NONE"}</td>
                  <td>
                    {item?.date
                      ? new Date(item?.date).toLocaleDateString("en-US")
                      : ""}
                  </td>
                  <td>{item?.cause}</td>
                </tr>
              );
            })}
        </tbody>
      </table>
      <div style={{ textIndent: "5rem", marginTop: "2rem" }}>
        <p>
          Issued in compliance with Executive Order No. 54 dated August 10,
          1954, and in accordance with Circular No. 58 dated Audust 10, 1954 of
          the System
        </p>
      </div>
      <div style={{ textIndent: "5rem" }}>
        <p>
          Issued at the Bureau of Immigration, Human Resource Management Section
          (HRMS), Human Resource Development Division (HRDD), Intramuros, Manila
        </p>
      </div>
      {/* remarks  */}
      <div>
        {sortedObjects?.length > 0 &&
          sortedObjects.map((item, index) => {
            return (
              <p style={{ fontSize: "13px" }} key={index}>
                {item.remarks ? `*${item.remarks}` : ""}
              </p>
            );
          })}
      </div>
      {remarks.length > 0 &&
        remarks.map((item, index) => {
          const remarks = item.remarks.replace(/\n/g, "<br />");
          return (
            <div className="border">
              <p
                style={{ fontSize: "13px" }}
                dangerouslySetInnerHTML={{ __html: `* ${remarks}` }}
              />
            </div>
          );
        })}
      {/* footer  */}
      <div style={{ display: "grid", marginTop: "3rem" }}>
        {/* <p style={{ padding: 0, margin: 0 }}>
          MAINDEN MIDDLE NAME: {middleName}
        </p> */}
        <p style={{ padding: 0, margin: 0 }}>
          SERVICE RECORD / {employeeName}{" "}
        </p>
        <p>{formatDate(new Date())}</p>
        <div style={{ display: "grid", justifyContent: "end" }}>
          <div style={{ width: "100%", textAlign: "center" }}>
            <p style={{ padding: 0, margin: 0 }}>
              <b>ATTY. CRIS M. VILLALOBOS</b>
            </p>
            <p style={{ padding: 0, margin: 0 }}>Acting Chief.HRDD</p>
          </div>
        </div>
      </div>
    </div>
  );
}
